export default __webpack_public_path__ + "static/media/ArrowLeftPayment.31320f9f.svg";